module.exports = __webpack_public_path__ + "img/gallary06.44d7badb.webp";